import { useEffect, useState } from 'react';

type Props = {
  delay?: number;
};

/**
 * Delay variable value for some predefined delay time.
 */
export const useDelayedValue = ({ delay = 500 }: Props = {}) => {
  const [value, setValue] = useState(delay === 0);

  useEffect(() => {
    // We want to have the delay for the component.
    const timeout = setTimeout(() => setValue(true), delay);
    return () => clearTimeout(timeout);
  }, [delay]);

  return [value];
};
